export default __webpack_public_path__ + "04169328d415c26865e652ddee7bb919.webp";